<template>
  <input-facade 
    :class="'text size-s'" 
    :mask="'##/##/####'" 
    :placeholder="'mm/dd/yyyy'" 
    :id="'field-' + options.id" 
    :name="'fields[' + options.id + ']'" 
    :masked="true"
    v-model="fieldValue" />
</template>

<script>
import dayjs from 'dayjs'
import { InputFacade } from 'vue-input-facade'
const customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)

export default { 
  name: 'DateTextField',
  components: {
    InputFacade
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    value: {
      type: String
    }
  },
  methods: {
    validate () {
      return dayjs(this.value, 'YYYY-MM-DD', true).isValid()
    }
  },
  computed: {
    isValid () {
      return dayjs(this.value, 'YYYY-MM-DD', true).isValid()
    },
    fieldValue: {
      get() {
        let complete = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(this.value)
        if (complete) {
          let dt = dayjs(this.value)
          return dt.format('MM/DD/YYYY')
        } else {
          return false
        }
      },
      set(val) {

        let complete = /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/.test(val)
        let date_string = val
        if (complete) {
          let dt = dayjs(val)
          date_string = dt.format('YYYY-MM-DD')
        }

        this.$commit.setFieldValue({
          key: 'field-' + this.options.id, 
          value: date_string
        })
      }
    }
  }
}
  
</script>
